import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/global.scss";

import "./services/i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(<App />);
